export const sortGrid = (data: Array<any>, key: string) => {
	data.sort((a: any, b: any) => {
		if (a[key] < b[key]) return -1;

		if (a[key] > b[key]) return 1;

		return 0;
	});
};
